import axios from 'axios';
import {
  buildChecklistItemsFromSignals,
  isOnboardingManagedChecklistRow,
  type OnboardingChecklistPayload,
} from './onboardingChecklistFilters';

interface FetchChecklistsResponse {
  success?: boolean;
  data?: {
    userCheckList?: Array<{ id: number; query?: string | null; key?: string | null }>;
  };
}

export async function syncOnboardingChecklists(
  userId: number,
  selectedSignalIds: string[],
): Promise<void> {
  const fetchResponse = await axios.get<FetchChecklistsResponse>(
    `/api/users/fetch-checklists/${userId}`,
  );
  const existingRows = fetchResponse.data?.data?.userCheckList ?? [];

  const rowsToDelete = existingRows.filter(isOnboardingManagedChecklistRow);

  await Promise.all(
    rowsToDelete.map((row) =>
      axios.post('/api/users/delete/checklist', { id: row.id, user_id: userId }),
    ),
  );

  const dataObj: OnboardingChecklistPayload[] = buildChecklistItemsFromSignals(selectedSignalIds);
  if (dataObj.length === 0) {
    return;
  }

  await axios.post('/api/users/add-checklist', {
    dataObj,
    user_id: userId,
  });
}
